const apiUrl = process.env.REACT_APP_API_URL;

const getPrograms = (token, cb) => {
    fetch(`${apiUrl}/programs`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
        }
    })
        .then(res => res.json())
        .then(res => {
            cb(res);
        });
};

export default getPrograms;
